import React from "react";
import Bill from "../../images/icons/Bill_Icon";
import MasterCard from "../../images/icons/MasterCardIcon";
import VisaCard from "../../images/icons/VisaCardIcon";
import { StaticImage } from "gatsby-plugin-image";

export default function PaymentIcons() {
  return (
    <div className="flex h-5 w-full self-center ">
      <Bill 
        width="25" 
        height="25" 
        className="m-px flex self-center" 
      />
      <MasterCard
        width="25" 
        height="25" 
        className="m-px flex self-center" 
      />
      <VisaCard 
        width="25" 
        height="25" 
        className="m-px flex self-center"
        fill="white"
      />
      <StaticImage
        src='../../images/icons/codiIcon.png'
        alt="Plus Circle"
        placeholder="blurred"
        className="w-10"
      />
    </div>
  );
}
